import useCheckoutStore from "../../../../cart/store/checkoutStore";
import DiscountCartSummary from "../../../../pricing/discount/DiscountCartSummary";
import {getLineSummary} from "../../../../pricing/calculator/summaryCalculator";


const CartDiscounts = () => {

    const lines = useCheckoutStore(state => state.products?.lines);
    const summary = getLineSummary(lines);


    if(summary.totalSaved <= 0 && summary.furtherSavings <= 0)
        return;

    return (
        <div className="cart-section cart-r">
            <p className="cart-h2">Discounts</p>
            <DiscountCartSummary summary={summary} />
        </div>
    )

}

export default CartDiscounts;